import { veosSignatureApi } from "@/api/veos/";
import { IDocapost, IDocument } from "@/models/veos";

/**
 * Services pour la signature des documents
 */
export default class SignatureService {

    /**
     * Liste les documents du client.
     * @returns  {IDocument[]} la liste des documents
     */
    public listDocuments() {
        return veosSignatureApi.listDocumentsByIdPer();
    }

    /**
     * Bascule vers Docapost pour signer le document.
     * @param idDoc l'identifiant du document dans VEOS
     * @returns {IDocapost} les informations nécessaires à la redirection vers Docapost
     */
    public goToSignDocument(idDoc: string) {
        return veosSignatureApi.goToSignDocument(idDoc);
    }

    /**
     * Récupère le document signé chez Docapost.
     * @param {string} idDoc l'identifiant du document dans VEOS
     * @returns le document signé
     */
    public downloadDocapostSignDocument(idDoc: string) {
        return veosSignatureApi.downloadDocapostSignDocument(idDoc);
    }

    /**
     * Récupère le logo de la compagnie
     * @returns le logo
     */
    public downloadLogo() {
        return veosSignatureApi.downloadLogo();
    }

    /**
     * Met à jour le document dans VEOS :
     * - date signature
     * - etat signature
     * - id document chez Docapost
     * @param {string} idDocapost l'identifiant du document chez Docapost
     * @param {string} idDoc l'identifiant du document dans VEOS
     * @returns {void}
     */
    public updateSignDocument(idDocapost: string, idDoc: string) {
        return veosSignatureApi.updateSignDocument(idDocapost, idDoc);
    }

    /**
     * Récupère les informations du client
     * @returns les informations du client
     */
    public getInfosPer() {
        return veosSignatureApi.getInfosPersonne();
    }
}
